import checkRuneIntegrity from '../helpers/checkRuneIntegrity'
import trackRuneChanges from '../helpers/trackRuneChanges'
//------------------------
// process rune integrity
//------------------------
export default function processRuneIntegrity({
  change = null,
  character_id,
  rune,
  changed_runes,
  original_runes,
} = {}) {
  console.log('-----------------------------------------')
  console.log('IN processRuneIntegrity change = ', change)
  //------------------------------------------
  // apply integrity rules using shared logic
  //------------------------------------------
  const { updated, changes } = checkRuneIntegrity({ rune, changedField: change.key })
  //-------------------------------------
  // apply updates back to original rune
  //-------------------------------------
  Object.assign(rune, updated)
  //-----------------------------
  // track each integrity change
  //-----------------------------
  changes.forEach((integrityChange) => {
    console.log(
      `Integrity: set rune.${integrityChange.key} = ${integrityChange.value} (${integrityChange.reason})`,
    )

    changed_runes = trackRuneChanges({
      change: {
        key: integrityChange.key,
        value: integrityChange.value,
      },
      rune,
      original_runes,
      changed_runes,
      character_id: character_id,
    })
  })

  return changed_runes
}
